export const PAYMENT_SCOPE = {
    FULL_BOOKING: 'full_booking',
    PARTIAL_ITEMS: 'partial_items',
}

export const STEP = {
    SCOPE: 1,
    DETAILS: 2,
    SUMMARY: 3,
}

export const STEPS = [
    { id: STEP.SCOPE, label: 'Payment scope' },
    { id: STEP.DETAILS, label: 'Payment details' },
    { id: STEP.SUMMARY, label: 'Summary' },
]

export const CASH_PAYMENT_TYPE_ID = 1

export const AGENT_DEPOSIT_PAYMENT_TYPE_ID = -100

export const buildPaymentLine = (toPay) => ({
    type: CASH_PAYMENT_TYPE_ID,
    toPay,
    amountReceived: null,
    isAgentPayment: false,
})

export const buildBillingDetails = () => ({
    vat: '',
    businessName: '',
    address: '',
    city: '',
    postalCode: '',
    country: null,
    selectedCountry: null,
})



// WEBPACK FOOTER //
// ./src/tools/modal/ReservationPayIn/payInHelpers.js